
<script>
  import { request } from './../../helpers/api'
  import { userStore, snackBarStore, clientStore } from '../../state/store'
  import AddressBlock from '../../components/AddressBlock.svelte'
  import { isUserAdmin } from './../../helpers/utils'
  import TextInput from '../../components/TextInput.svelte'
  import GenerateReport from '../../components/GenerateReport.svelte'
  import { replace } from 'svelte-spa-router'
  import { t } from '../../i18n/i18n'
  
  export let client = {}
  export let address = {}
  let editing = false

  let form = {
    name: '',
    email: '',
    phone_number: ''
  }

  const cancelEdit = () => {
    form.name = client.name
    form.email = client.email
    form.phone_number = client.phone_number
    editing = false
  }

  const openEdit = () => {
    form.name = client.name
    form.email = client.email
    form.phone_number = client.phone_number
    editing = true   
  }

  const deleteClient = async () => {
    if(confirm(`
      This will delete the client, all of it's locations, and all work logs permanently.
      Ensure that you have generated the reports needed for this client before deleting.
      
      This can not be undone.
    `)) {
      try {
       const response = await request({
        url: '/api/clients',
        method: 'DELETE',
        body: JSON.stringify({
          client: client._id,
          tenant: $userStore.tenant_id,
        })
      })
      snackBarStore.set({ message: 'Client Deleted', type: 'success', selfDestruct: true  })
      replace('/clients/')
      } catch (error) {
        snackBarStore.set({ message: $t.something_wrong, type: 'error', selfDestruct: true }) 
      }
    }
  }

  const submitForm = async () => {   
    try {
      // Submit form data
      const response = await request({
        url: '/api/clients',
        method: 'PUT',
        body: JSON.stringify({
          ...form,
          tenant: $userStore.tenant_id,
          client: client._id
        })
      })

      // Update location in the store
      clientStore.update((clients) => {
        let updated = clients.find(client => client._id === response._id)
        updated.name = response.name
        updated.email = response.email
        updated.phone_number = response.phone_number
        return [
          ...clients
        ]
      })
      snackBarStore.set({ message: $t['Client Updated'], type: 'success', selfDestruct: true  })
      cancelEdit()
    } catch (error) {
      snackBarStore.set({ message: $t.something_wrong, type: 'error' })
    }
  }

</script>

<header>
  {#if !editing}
    <h1>{client.name}</h1>
    <div>
      <AddressBlock {address}/>
    </div>
  {:else}
  <form on:submit|preventDefault={submitForm}>
    <TextInput
    id='name'
    label='{$t['Client Name']}'
    validityMessage='{$t['Please enter a Client name']}'
    on:input={event => (form.name = event.target.value)}
    value="{client.name}" />
    <TextInput
      id='email'
      label='{$t.email}'
      validityMessage='{$t.valid_email}'
      on:input={event => (form.email = event.target.value)}
      value={client.email} />
    <TextInput
      id='phone_number'
      label='{$t['phone']}'
      validityMessage='{$t['Please enter a phone number']}'
      on:input={event => (form.phone_number = event.target.value)}
      value={client.phone_number} />

    <div class="g-admin-buttons">
      <button on:click={cancelEdit} type="button">{$t.cancel}</button>
      <button class="update" type="submit">{$t.update}</button>
      <button class="delete" type="button" on:click={deleteClient}> {$t.delete} </button>
    </div>
  </form>

  {/if}
  {#if isUserAdmin($userStore)}
    {#if !editing}
      <div class="g-admin-buttons">
        <button on:click={openEdit} type='button' action='edit'>{$t.edit}</button>
      </div>
    {/if}
  {/if}
  {#if !editing}
    <GenerateReport client={client} />
  {/if}
</header>
